import React from "react";
import { Routes, Route } from "react-router-dom";
import InterviewAssesment from "../InterviewerAssessment/Pages/InterviewerAssessmentSheet";
import InterviewSchedule from "../ScheduleInterview/Pages/InterviewSchedule";
import Footer from "../../Employee/EmployeeLayout/Pages/Footer";

const InterviewerRoutes = () => {
   return (
    <div className="min-h-screen flex flex-col">

      {/* Page Content */}
      <div className="flex-1">
        <Routes>
          <Route
            path="Interview-Assessment/:InterviewUID"
            element={<InterviewAssesment />}
          />

          <Route
            path="/Interview-Scheduling-Request/:InterviewUID"
            element={<InterviewSchedule />}
          />
        </Routes>
      </div>

      {/* Footer */}
      <Footer />

    </div>
  );
};

export default InterviewerRoutes;
